// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* style it, the bare minimum */
:root {
  --sh-modal-margin:0px;
}

.dialog-overlay {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 99;
  background-color: rgba(0, 0, 0, 0.5) !important;
  display: flex;
  align-items: center;
  justify-content: center;
}

.dialog {
  min-height: 150px;
  background-color: #fff !important;
  width: clamp(250px, 30vw, 90vw);
  z-index: 999;
  overflow: hidden;
  outline: 0;
  display: flex;
  flex-direction: column;
  max-height: calc(100vh - 200px);
  position: relative;
  background-clip: padding-box;
  box-shadow: 0 16px 24px 2px rgba(0, 0, 0, 0.14), 0 6px 30px 5px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.3) !important;
}

.dialog-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 35px;
  background: var(--primaryColor);
  box-shadow: 0px 1px 0px var(--primaryColor);
}

.dialog-title {
  text-align: center !important;
  width: 100%;
  font-size: 1rem !important;
  color: #fff !important;
  padding: 10px;
  font-weight: bold;
}

.dialog-body {
  position: relative;
  flex: 1 1 auto;
  padding: 15px;
  overflow-y: auto;
  min-height: 50px;
  max-height: 200px;
  color: #252525 !important;
  font-size: 1rem !important;
  text-align: left;
  padding-top: 15px 15px;
}

.check-list {
  display: flex;
  flex-direction: row;
  gap: 10px;
  margin-bottom: 5px;
}
.check-list label {
  cursor: pointer;
}

input[type=radio]:checked {
  background-color: #0476af;
}

input[type=radio]:checked:after {
  content: "";
  color: white;
}

input[type=radio] {
  text-align: center;
  display: table-cell;
  vertical-align: middle;
  width: 20px !important;
  height: 20px !important;
  border-radius: 10%;
  border: 1px solid #065a76;
  box-shadow: none;
  font-size: 1em;
}

.dialog-footer {
  display: flex;
  flex-direction: row;
  align-items: center;
  align-self: flex-end;
  column-gap: normal;
  padding: 10px;
}
.dialog-footer .btn {
  --bs-btn-line-height:1.2 !important;
  font-size: 0.9rem !important;
  padding: 5px 20px;
  color: #fff;
  background: var(--primaryColor);
  margin-right: 15px;
  border: none;
  cursor: pointer;
}
.dialog-footer .btn:first-child {
  background: #fff;
  color: #363636;
  border: 1px solid #dbdbdb;
}

/* extra styles and animation */
.dialog-bottom-sheet .dialog-overlay {
  align-items: flex-end;
}

.dialog-full-height .dialog {
  height: calc(100vh - var(--sh-modal-margin) * 2);
}

.dialog-full-screen .dialog {
  min-height: calc(var(--vh, 1vh) * 100);
  max-height: calc(var(--vh, 1vh) * 100);
  width: 100vw;
}

.dialog-half-screen .dialog-overlay {
  justify-content: flex-start;
}

.dialog-half-screen .dialog {
  max-width: 50vw;
  min-height: calc(var(--vh, 1vh) * 100);
  max-height: calc(var(--vh, 1vh) * 100);
}

.reverse .dialog-overlay {
  justify-content: flex-end;
}

.animate.fromleft .dialog {
  transform: translateX(-100%);
  animation: fromleft 0.15s var(--sh-trans-func) 0.15s;
  animation-fill-mode: forwards;
}

.animate.fromright .dialog {
  transform: translateX(100%);
  animation: fromright 0.15s var(--sh-trans-func) 0.15s;
  animation-fill-mode: forwards;
}

.animate.fromtop .dialog {
  transform: translateY(-100%);
  animation: fromtop 0.15s var(--sh-trans-func) 0.15s;
  animation-fill-mode: forwards;
}

.animate.frombottom .dialog {
  transform: translateY(100%);
  animation: frombottom 0.15s var(--sh-trans-func) 0.15s;
  animation-fill-mode: forwards;
}

@keyframes fromleft {
  from {
    transform: translateX(-100%);
  }
  to {
    transform: translateX(0);
  }
}
@keyframes fromright {
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(0);
  }
}
@keyframes frombottom {
  from {
    transform: translateY(100%);
  }
  to {
    transform: translateY(0);
  }
}
@keyframes fromtop {
  from {
    transform: translateY(-100%);
  }
  to {
    transform: translateY(0);
  }
}`, "",{"version":3,"sources":["webpack://./src/app/core/listdialog/listdialog.component.scss"],"names":[],"mappings":"AAAA,+BAAA;AAEA;EACI,qBAAA;AAAJ;;AAGI;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,+CAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAAN;;AAGI;EACE,iBAAA;EACA,iCAAA;EACA,+BAAA;EACA,YAAA;EACA,gBAAA;EACA,UAAA;EACA,aAAA;EACA,sBAAA;EACA,+BAAA;EACA,kBAAA;EACA,4BAAA;EACA,kIAAA;AAAN;;AAII;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;EACA,+BAAA;EACA,2CAAA;AADN;;AAGI;EACE,6BAAA;EACA,WAAA;EACA,0BAAA;EACA,sBAAA;EACA,aAAA;EACA,iBAAA;AAAN;;AAGI;EACE,kBAAA;EACA,cAAA;EACA,aAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,0BAAA;EACA,gBAAA;EACA,sBAAA;AAAN;;AAGI;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;AAAR;AACQ;EACE,eAAA;AACV;;AAEI;EACI,yBAAA;AACR;;AACM;EACE,WAAA;EACA,YAAA;AAER;;AAAM;EACE,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,sBAAA;EACA,uBAAA;EAEA,kBAAA;EACA,yBAAA;EACA,gBAAA;EACA,cAAA;AAER;;AACI;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,aAAA;AAEN;AAAM;EACE,mCAAA;EACA,4BAAA;EACA,iBAAA;EACA,WAAA;EACA,+BAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;AAER;AACM;EACE,gBAAA;EACA,cAAA;EACA,yBAAA;AACR;;AAGI,+BAAA;AAEA;EACE,qBAAA;AADN;;AAII;EACE,gDAAA;AADN;;AAII;EACE,sCAAA;EACA,sCAAA;EACA,YAAA;AADN;;AAII;EACE,2BAAA;AADN;;AAGI;EACE,eAAA;EACA,sCAAA;EACA,sCAAA;AAAN;;AAGI;EACE,yBAAA;AAAN;;AAGI;EACE,4BAAA;EACA,oDAAA;EACA,6BAAA;AAAN;;AAGI;EACE,2BAAA;EACA,qDAAA;EACA,6BAAA;AAAN;;AAGI;EACE,4BAAA;EACA,mDAAA;EACA,6BAAA;AAAN;;AAGI;EACE,2BAAA;EACA,sDAAA;EACA,6BAAA;AAAN;;AAGI;EACE;IACE,4BAAA;EAAN;EAEI;IACE,wBAAA;EAAN;AACF;AAEI;EACE;IACE,2BAAA;EAAN;EAEI;IACE,wBAAA;EAAN;AACF;AAEI;EACE;IACE,2BAAA;EAAN;EAEI;IACE,wBAAA;EAAN;AACF;AAEI;EACE;IACE,4BAAA;EAAN;EAEI;IACE,wBAAA;EAAN;AACF","sourcesContent":["/* style it, the bare minimum */\n\n:root{\n    --sh-modal-margin:0px;\n   }\n   \n    .dialog-overlay {\n      position: fixed;\n      top: 0;\n      right: 0;\n      bottom: 0;\n      left: 0;\n      z-index: 99;\n      background-color:rgba(0, 0,0, 0.5) !important;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n    }\n    \n    .dialog {\n      min-height:150px;\n      background-color:#fff !important;\n      width: clamp(250px,30vw, 90vw);\n      z-index:999;\n      overflow: hidden;\n      outline: 0;\n      display: flex;\n      flex-direction: column;\n      max-height: calc(100vh - 100px * 2);\n      position: relative;\n      background-clip: padding-box;\n      box-shadow: 0 16px 24px 2px rgba(#000, 0.14), 0 6px 30px 5px rgba(#000, 0.12),\n        0 8px 10px -5px rgba(#000, 0.3) !important;\n    }\n    \n    .dialog-header {\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      min-height:35px;\n      background:var(--primaryColor);\n      box-shadow:0px 1px 0px var(--primaryColor);\n    }\n    .dialog-title{\n      text-align: center !important;\n      width:100%;\n      font-size:1rem !important;\n      color:#fff !important;\n      padding:10px;\n      font-weight: bold;\n    }\n    \n    .dialog-body {\n      position: relative;\n      flex: 1 1 auto;\n      padding:15px;\n      overflow-y: auto;\n      min-height:50px;\n      max-height:200px;\n      color:#252525 !important;\n      font-size:1rem !important;\n      text-align: left;\n      padding-top: 15px 15px;\n    }\n\n    .check-list{\n        display: flex;\n        flex-direction: row;\n        gap: 10px;\n        margin-bottom:5px;\n        label{\n          cursor: pointer;\n        }\n    }\n    input[type='radio']:checked {\n        background-color: #0476af;\n      }\n      input[type='radio']:checked:after {\n        content: '';\n        color:white;\n      }\n      input[type='radio']{\n        text-align: center;\n        display: table-cell;\n        vertical-align: middle;\n        width:20px !important;\n        height:20px !important;\n        // appearance:none;\n        border-radius:10%;\n        border:1px solid #065a76;\n        box-shadow: none;\n        font-size: 1em;\n      }\n  \n    .dialog-footer{\n      display: flex;\n      flex-direction: row;\n      align-items: center;\n      align-self: flex-end;\n      column-gap: normal;\n      padding:10px;\n  \n      .btn{\n        --bs-btn-line-height:1.2 !important;\n        font-size:.9rem !important;\n        padding:5px 20px;\n        color:#fff;\n        background: var(--primaryColor);\n        margin-right:15px;\n        border: none;\n        cursor: pointer;\n      }\n  \n      .btn:first-child{\n        background:#fff;\n        color:#363636;\n        border:1px solid #dbdbdb;\n      }\n    }\n    \n    /* extra styles and animation */\n    \n    .dialog-bottom-sheet .dialog-overlay {\n      align-items: flex-end;\n    }\n    \n    .dialog-full-height .dialog {\n      height: calc(100vh - var(--sh-modal-margin) * 2);\n    }\n    \n    .dialog-full-screen .dialog {\n      min-height: calc(var(--vh, 1vh) * 100);\n      max-height: calc(var(--vh, 1vh) * 100);\n      width: 100vw;\n    }\n    \n    .dialog-half-screen .dialog-overlay {\n      justify-content: flex-start;\n    }\n    .dialog-half-screen .dialog {\n      max-width: 50vw;\n      min-height: calc(var(--vh, 1vh) * 100);\n      max-height: calc(var(--vh, 1vh) * 100);\n    }\n    \n    .reverse .dialog-overlay {\n      justify-content: flex-end;\n    }\n    \n    .animate.fromleft .dialog {\n      transform: translateX(-100%);\n      animation: fromleft 0.15s var(--sh-trans-func) 0.15s;\n      animation-fill-mode: forwards;\n    }\n    \n    .animate.fromright .dialog {\n      transform: translateX(100%);\n      animation: fromright 0.15s var(--sh-trans-func) 0.15s;\n      animation-fill-mode: forwards;\n    }\n    \n    .animate.fromtop .dialog {\n      transform: translateY(-100%);\n      animation: fromtop 0.15s var(--sh-trans-func) 0.15s;\n      animation-fill-mode: forwards;\n    }\n    \n    .animate.frombottom .dialog {\n      transform: translateY(100%);\n      animation: frombottom 0.15s var(--sh-trans-func) 0.15s;\n      animation-fill-mode: forwards;\n    }\n    \n    @keyframes fromleft {\n      from {\n        transform: translateX(-100%);\n      }\n      to {\n        transform: translateX(0);\n      }\n    }\n    @keyframes fromright {\n      from {\n        transform: translateX(100%);\n      }\n      to {\n        transform: translateX(0);\n      }\n    }\n    @keyframes frombottom {\n      from {\n        transform: translateY(100%);\n      }\n      to {\n        transform: translateY(0);\n      }\n    }\n    @keyframes fromtop {\n      from {\n        transform: translateY(-100%);\n      }\n      to {\n        transform: translateY(0);\n      }\n    }\n    "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
